import React from 'react';
import { GlobeIcon, UsersIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function CredibilityBar() {
  const {
    language
  } = useLanguage();
  const t = translations[language].credibility;
  return <section className="py-8 md:py-12 px-4 bg-teal-950/30 border-y border-teal-800/30" data-id="element-7">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-6 md:gap-8 text-center" data-id="element-8">
        <div className="flex items-center gap-3" data-id="element-9">
          <UsersIcon className="w-6 h-6 text-yellow-400" data-id="element-10" />
          <span className="text-sm md:text-base text-teal-200" data-id="element-11">
            {t.readers}
          </span>
        </div>
        <div className="flex items-center gap-3" data-id="element-12">
          <GlobeIcon className="w-6 h-6 text-yellow-400" data-id="element-13" />
          <span className="text-sm md:text-base text-teal-200" data-id="element-14">
            {t.featured}
          </span>
        </div>
      </div>
    </section>;
}